
import discount from '../../src/assets/images/discount.svg'
import star from '../../src/assets/images/star.svg'


export default function RazorpayRize({message,button=false}) {
    return (
        <div
            style={{
                width: "100%",
                border: '1px solid #417AD1',
                borderRadius: '5px',
                background: 'linear-gradient(to right, rgba(65, 122, 209, 0.2), rgba(75, 167, 221, 0.2))',
                padding: "7px 10px",
                display: "flex",
                alignItems: "center",
                justifyContent:'space-between',
                gap: "8px",
            }}
        >
            <div style={{
                display: "flex",
                alignItems: "center",
                gap:'8px'
}}>
                <img style={{
                    width: "20px",
                    height: "20px",
                    objectFit: "contain",
                    display: "block",
                }} alt='' src={discount} />
            
            <div
                style={{
                    color: "#2C358A",
                    fontSize: "16px",
                    fontWeight: "800",
                    display: "flex",
                    alignItems: "center",
                    fontFamily:'figtree'
                }}
            >
                {button &&
                    <span
                        style={{
                            color: "#2C358A",
                            fontSize: "15px",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center",
                            fontFamily: 'figtree',
                            lineHeight: '100%',
                            letterSpacing: '0%'
                        }}
                    >This is a&nbsp;</span>}
                {button ?' Razorpay Rize user - ': 'Sign up and enjoy ' }
                <span style={{
                    background: 'linear-gradient(to right, rgba(43,110,212), rgba(20,90,197))',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',                    
                    fontSize: "14px",
                    fontWeight: "800",
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'figtree'
                }}>&nbsp;{button ? 'exclusive partner benefits are active on this account.':'3% off on freight invoices.'}</span>
            </div>
            </div>
            {button && <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    background: 'linear-gradient(to right, rgba(44, 53, 138, 1), rgba(43, 110, 212, 1))',
                    color: "#fff",
                    padding: "4px 8px",
                    borderRadius: "20px",
                    fontWeight: "700",
                    fontSize: "14px",
                    fontFamily: 'figtree',
                    whiteSpace: "nowrap",
                }}
            >
                <img style={{
                    width: "18px",
                    height: "18px",
                }} alt='' src={star} />
                Rize Member
            </div>}
        </div>
    );
}


export const OfferBanner = ({borderColour,bgColour,imageUrl = discount,message,button=false}) => {    
    return (
        <div
            style={{
                border: `1px solid ${borderColour} `,
                background: bgColour,
                borderRadius: "8px",
                padding: "18px 24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                <img
                    src={imageUrl}
                    alt="discount"
                    style={{
                        width: "32px",
                        height: "32px",
                        display: "block",
                    }}
                />
                <div>
                    <div
                        style={{
                            color: button ? "#2C358A" : '#2C8A57',
                            fontSize: "16px",
                            fontWeight: "900",
                            fontFamily:'figtree',
                            lineHeight:'100%',
                            letterSpacing:'0%'
                        }}
                    >
                        Razorpay Rize member offer
                    </div>

                    <div
                        style={{
                            fontSize: "14px",
                            fontFamily:'figtree',
                            lineHeight:'100%',
                            fontWeight:'500',
                            marginTop: "10px",
                            color:'black'
                        }}
                    >
                        {message}
                    </div>
                </div>
            </div>

           { button  && <div
                style={{
                    backgroundColor: "#f28c38",
                    color: "white",
                    fontFamily:'figtree',
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontWeight: "700",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                }}
            >
                3% Off
            </div>}
        </div>
    );
};

